import React from "react";
import {
    Grid,
    Typography,
    Stack,

} from "@mui/material";
import passwordResetModel, {passwordResetModelType} from '../../forms/models/passwordResetModel';
import passwordResetSchema from '../../forms/schemas/passwordResetSchema';
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import LoadingCover from "components/common/LoadingCover";
import PasswordResetFields from "components/forms/PasswordResetFields";
import { LockReset } from "@mui/icons-material";
import { IconContainer, ResetIcon, StyledButton } from '../../common/styledComponents/AuthComponents';

type MyFormValues = passwordResetModelType

const passwordResetModelInitial = passwordResetModel.initialValues

const passwordResetFormSchema = Yup.object().shape({...passwordResetSchema})

interface OwnProps {
    sendReset: (newPassword: string) => void ;
    isLoading: boolean;
    apiError?: string
}

const ResetPasswordForm = (props: OwnProps) => {
    const {sendReset, isLoading, apiError} = props

    const handleSubmit = async (values: MyFormValues) => {
        sendReset(values.password)
    }
    return (
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
            <IconContainer>
                <ResetIcon>
                    <LockReset sx={{ color: 'white', fontSize: 28 }} />
                </ResetIcon>
            </IconContainer>

            <Typography 
                variant="h5" 
                fontWeight="600" 
                color="primary" 
                align="center" 
                gutterBottom 
                data-cy="resetRequestHeader"
            >
                Reset Your Password
            </Typography>

            <Typography 
                variant="body2" 
                color="text.secondary" 
                align="center" 
                sx={{ mb: 4 }}
            >
                Please enter your new password below
            </Typography>

            <Formik
                initialValues={passwordResetModelInitial}
                onSubmit={handleSubmit}
                validationSchema={passwordResetFormSchema}
            >
                <Form data-cy={passwordResetModel.formId} style={{ width: '100%', maxWidth: '400px' }}>
                    <Stack spacing={4} width='100%' alignItems="center">
                        <PasswordResetFields 
                            apiError={apiError}
                        />

                        <StyledButton
                            variant="contained"
                            type="submit"
                            fullWidth
                            size="large"
                            data-cy={"resetRequestSubmit"}
                        >
                            Reset Password
                        </StyledButton>
                    </Stack>
                </Form>
            </Formik>

            {isLoading && <LoadingCover />}
        </Grid>
    )
}

export default ResetPasswordForm;
